import { createContext } from "react";

type Props = {
  balance: number | undefined;
  setBalance: SetState<number | undefined>;
  locked: boolean;
  setLocked: SetState<boolean>;
};

const BalanceLockContext = createContext<Props>({
  locked: false,
  setLocked: (_) => null,
  balance: undefined,
  setBalance: (_) => null,
});

export default BalanceLockContext;
